import { render } from "./QuizHeader.vue?vue&type=template&id=a5ec0834"
import script from "./QuizHeader.vue?vue&type=script&lang=js"
export * from "./QuizHeader.vue?vue&type=script&lang=js"
script.render = render

export default script